<template>
    <transition-group name="slide-fade">

        <form-feedback
        key="feedback"
        v-if="achieved" />

        <section
        key="form"
        v-else>

            <form-progress />
            
            <div 
            class="row mt-5"
            v-if="section">

                <div class="col-md-4">

                    <transition-group 
                    tag="ul"
                    class="list-group mb-4"
                    name="slide-fade">
                        
                        <li class="list-group-item" 
                        :key="item.id"
                        :class="{active: item.id == section.id}"
                        @click="setSection(item.id)"
                        v-for="item in sections">
                            {{$trans(item.name)}}

                            <form-progress 
                            class="mt-3"
                            :light="true"
                            theme="bg-primary-desat"
                            :section="item.id" />

                        </li> <!-- /.list-group-item -->

                    </transition-group>

                </div> <!-- /.col -->
                

                <div class="col-md-8">
                    
                    <div class="row">
                        <form-row 
                        v-for="row in rows"
                        :key="'row-'+row.id" 
                        :row="row" />
                    </div> <!-- /.row -->


                    <transition-group name="slide-fade">
                        <form-section
                        :key="section.id"
                        :section="section" />
                    </transition-group>


                    <div class="mt-8 d-flex justify-content-between">

                        <button 
                        key="btn-prev"
                        :disabled="_.first(sections).id == section.id"
                        @click="prevSection()"
                        class="btn btn-outline-primary">
                            Précédant
                        </button>

                        <loading-button 
                        :loading="loading"
                        :disabled="stop || progress.percentage != 100"
                        v-if="_.last(sections).id == section.id"
                        @click="submit()"
                        class="d-inline-block btn btn-primary">
                            Envoyer
                        </loading-button>

                        <button 
                        v-else
                        :disabled="stop"
                        @click="nextSection()"
                        class="d-inline-block btn btn-primary">
                            Suivant
                        </button>

                    </div> <!-- /.d-flex -->

                </div> <!-- /.col -->

            </div> <!-- /.row -->


            <slot></slot>

        </section>

    </transition-group>
</template>

<script>

    import {mapState, mapGetters} from 'vuex'

    export default {

        data() {
            return {
                loading: false,
                section: null
            }
        },

        computed: {

            _() {
                return _;
            },
            
            index() {
                return _.findIndex(this.sections, s => s.id == this.section.id)
            },

            ...mapState({
                achieved: state => state.form.achieved,
                auth: state => state.form.auth,
                displayErrors: state => state.form.displayErrors,
                errors: state => state.app.errors
            }), 

            ...mapGetters('form', [
                'rows',
                'answers',
                'sections',
                'stop',
                'progress'
            ]),

            sectionProgress() {
                return this.progress.sections[this.section.id]
            }
        },

        methods: {

            scrollTop() {
                this.$scrollTo('#app', 500)
            },

            setErrors() {
                this.$store.commit('form/setDisplayErrors', false)
                this.$store.commit('form/setDisplayErrors', true)
                this.$store.commit('app/pushErrors', this.sectionProgress.errors)

                setTimeout(() => {
                    
                    this.$scrollTo('.invalid-feedback', 500, {
                        offset: -200
                    })

                }, 500)
            },

            resetErrors() {
                this.$store.dispatch('app/resetErrors')
                this.$store.commit('form/setDisplayErrors', false)
            },

            canNext() {
                this.setErrors()
                return this.sectionProgress.percentage == 100;
            },
            
            setSection(id) {
                this.$store.dispatch('form/saveForm')

                if(this.canNext())
                {
                    this.resetErrors()
                    this.section = _.find(this.sections, s => s.id == id)
                }
            },

            prevSection() {
                this.$store.dispatch('form/saveForm')
                this.scrollTop()
                this.section = this.sections[this.index - 1]
            },

            nextSection() {
                this.$store.dispatch('form/saveForm')
                
                if(this.canNext())
                {
                    this.scrollTop()
                    this.resetErrors()
                    this.section = this.sections[this.index + 1]
                }
            },

            submit() {
                this.loading = true

                this.$store
                .dispatch('form/submitForm')
                .then(() => { 
                    this.loading = false 
                })
                .catch(() => {
                    this.loading = false
                    this.$flash(this.$t('app.An error has occured'))
                })
            }
        },

        mounted() {
            var url = new URL(window.location);
            var key = url.searchParams.get('section');

            this.section = key 
            ? _.find(this.sections, s => s.key == key)
            : _.first(this.sections)
        },

        watch: {
            section(value) {
                var url = new URL(window.location);
                url.searchParams.set('section', value.key);
                window.history.pushState({}, '', url);
            },

            answers: {
                handler(value) {
                    if(this.displayErrors)
                    {
                        setTimeout(() => {
                            this.setErrors()
                        }, 100)
                    }
                },
                deep: true
            }
        }
        

    }

</script>